module.exports = __webpack_public_path__ + "static/media/5. Prisma4, Óleo y resina sobre lámina de acrílico, 30 x 30 x 6 cm, 2016 copy.ae92a8c1.png";